export const serverEndpoints = {
  direct: {
    label: 'Germany Direct',
    address: '162.19.152.28:7707',
    steamUrl: 'steam://run/1250//+connect%20162.19.152.28:7707',
    location: 'Germany',
  },
} as const;
